import * as React from "react";

function SvgVerticalCenter(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}><path d="M3 9h14v2H3zM10.6 18.4H9.4v-3.9l-1.3 1.3L7 15l3-3 3 3-1.1.8-1.3-1.3v3.9zM9.4 1.6h1.2v3.9l1.3-1.3L13 5l-3 3-3-3 1.1-.8 1.3 1.3V1.6z" /></svg>;
}

export default SvgVerticalCenter;